const gql = String.raw;

export const UPDATE_REPORT_LINKS_MUTATION = gql`
  mutation updateReportLinks($update: [ReportLinkInput]!, $delete: [Int!]!) {
    updateReportLinks(reportLinks: $update) { id reports { id } }
    deleteReportLinks(id: $delete)
  }
`;
